import React, { useState, useRef, useEffect } from 'react';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend
} from 'chart.js';
import { Pie } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

const StatusChart = ({ statusCounts }) => {
    const [selectedIndex, setSelectedIndex] = useState(null);
    const chartRef = useRef()

    const labels = [
        'Draft',
        'Pending (Warm Lead)',
        'Pending (Cold Lead)',
        'Closed Deal',
        'Cancelled'
    ];

    const backgroundColors = [
        '#0073a5', // Draft
        '#f6d227', // Warm Lead
        '#1b5e20', // Cold Lead
        '#00d0dc', // Closed
        '#c8172c'  // Cancelled
    ];

    const data = {
        labels,
        datasets: [
            {
                data: labels.map(label => statusCounts[label]),
                backgroundColor: labels.map((_, index) =>
                selectedIndex === null || selectedIndex === index
                    ? backgroundColors[index]
                    : '#d3d3d3'
                ),  
                borderWidth: 1,
                offset: labels.map((_, index) => (index === selectedIndex ? 30 : 0)) // Offset selected slice
            }
        ]
    };

    const options = {
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                callbacks: {
                    label: function(context) {
                        const data = context.dataset.data
                        const total = data.reduce((sum, val) => sum + val, 0)
                        const value = context.raw
                        const percent = total ? ((value / total) * 100).toFixed(1) : 0
                        return `${context.label}: ${value} (${percent}%)`
                    }
                }
            }
        },
        onClick: (event, elements) => {
            if (elements.length > 0) {
                const index = elements[0].index;
                setSelectedIndex(prev => (prev === index ? null : index));
            }
        }
    };

    return (
        <div style={{ textAlign: 'center' }}>
            <Pie ref={chartRef} data={data} options={options} />

            <div style={{
                marginTop: '20px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
                textAlign: 'left'
            }}>
                {labels.map((label, index) => (
                    <div key={label} style={{ display: 'flex', alignItems: 'center', marginBottom: 1}}>
                        <span style={{
                            width: 12,
                            height: 12,
                            backgroundColor: backgroundColors[index],
                            display: 'inline-block',
                            marginRight: 8,
                        }} />
                        <span style={{fontSize: 12}}>{label}</span>
                    </div>
                ))}
            </div>
        </div>
    )
};

export default StatusChart;
